import { render, staticRenderFns } from "./list_index.vue?vue&type=template&id=f2a2aecc&scoped=true"
import script from "./list_index.vue?vue&type=script&lang=js"
export * from "./list_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a2aecc",
  null
  
)

export default component.exports